module.exports = __webpack_public_path__ + "img/about-img-4.a76052d1.png";